module.exports = __webpack_public_path__ + "TRUONGhome-3.76d88436.png";